import { IState } from 'shared/store';
import { isActiveExperiment } from 'shared/utils/experiments/isActiveExperiment';

import { abUseExperimentsSelector } from '..';

export const NEWBUILDING_KPN_CHAT = 'newbuilding_kpn_chats_card_desktop';

export function selectNewbuildingKpnChatEnabled(state: IState): boolean {
  const experiments = abUseExperimentsSelector(state);
  const isExperimentEnabled = isActiveExperiment(experiments, NEWBUILDING_KPN_CHAT, 'B');
  const isFlagEnabled = state.rs.kpnChat.enabled;
  // Проверяет условие по региону и ЖК
  const isKpnChatEnabled = state.offerData.offer.kpnChatEnabled || false;

  return isFlagEnabled && isExperimentEnabled && isKpnChatEnabled;
}
